<template>
  <div class="effect-chain-selector">
    <div class="options">
      <el-select
        v-close-on-zoom
        :value="state.effectChain.id"
        placeholder="Effect Chain"
        class="effect-chain-select"
        :disabled="readonly"
        @input="effectChainKey => selectEffectChain(effectChainKey)"
      >
        <el-option
          v-for="effectChain in effectChains"
          :key="effectChain.id"
          :label="effectChain.name ? effectChain.name.en : effectChain.id"
          :value="effectChain.id"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'effect-chain-selector',
  components: {},
  props: [
    'effectChains',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        effectChain: {},
      },
    };
  },
  created() {
    this.state.effectChain = this.getData(this.ikey) || {};
    this.state.displayAdvancedOptions = !!this.state.effectChain.absolute;
    this.emitter.trigger('process', this.control);
    this.emitter.on('zoom', () => {
      const effectChainSelect = this.$refs['effectChainSelect'];
      if (!effectChainSelect) {
        return;
      }
      effectChainSelect.visible = false;
    });
  },
  methods: {
    selectEffectChain(effectChainId) {
      const effectChain = this.effectChains.find(ec => ec.id === effectChainId);
      this.state.effectChain = {
        type: 'CUSTOM_EFFECT_CHAIN',
        id: effectChainId,
        nodes: effectChain.nodes,
        updatedAt: effectChain.updatedAt,
      };
      this.update();
      this.$analytics.event('Authoring Tool', 'effect_chain_selected', effectChain.name.en);
    },
    update() {
      this.putData(this.ikey, this.state.effectChain);
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.effect-chain-select {
  width: 300px;
}

.options {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
